// Never forward capability headers or feature bodies through an HTTP redirect.
// Feature authentication uses its explicit header, not ambient browser cookies.
export const PRIVATE_FETCH_OPTIONS = Object.freeze({
  redirect: 'error',
  credentials: 'omit',
  cache: 'no-store',
  referrerPolicy: 'no-referrer',
});

// Static-host fallbacks and unavailable API routes can return HTML even with 200.
// Never display that response body or treat it as a successful privacy action.
export async function readPrivacyResponse(response) {
  const unavailable = () => new Error('Privacy service unavailable. Please retry shortly.');
  const contentType = response.headers?.get('content-type');
  if (contentType && !/^application\/(?:[a-z0-9.+-]+\+)?json(?:\s*;|$)/i.test(contentType)) throw unavailable();
  let data;
  try { data = await response.json(); } catch { throw unavailable(); }
  if (!data || typeof data !== 'object' || Array.isArray(data)) throw unavailable();
  return data;
}

export function validateConsentState(data) {
  const keys=['chat','voice','scene','assessment','contact','ar'];
  if(!Number.isInteger(data?.revision)||data.revision<0||!Array.isArray(data.receipts)||
      !(Date.parse(data.expiresAt)>Date.now())||keys.some(key=>typeof data.scopes?.[key]!=='boolean')||(data.scopes?.review!==undefined&&typeof data.scopes.review!=='boolean')) {
    throw new Error('Privacy service returned incomplete choices. Please retry.');
  }
  return data;
}

export async function privateFetch(url, init = {}, timeoutMs = 15000) {
  const controller=new AbortController();
  const abort=()=>controller.abort();
  if(init.signal?.aborted)abort();
  init.signal?.addEventListener('abort',abort);
  const timer=setTimeout(abort,timeoutMs);
  try {return await fetch(url,{...init,...PRIVATE_FETCH_OPTIONS,signal:controller.signal});}
  finally {clearTimeout(timer);init.signal?.removeEventListener('abort',abort);}
}
